export default {
    indexPartnerCompanies:  { method: 'get',    url: 'partner_companies' },
    createPartnerCompany:   { method: 'post',   url: 'partner_companies'},
    updatePartnerCompany:   { method: 'put',    url: 'partner_companies/{id}'},
    destroyPartnerCompany:  { method: 'delete', url: 'partner_companies/{id}'}
}